/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TensionGuide_tension$ref = any;
type TensionGuide_viewer$ref = any;
type TensionInfo_tension$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TensionProcessModal_tension$ref: FragmentReference;
declare export opaque type TensionProcessModal_tension$fragmentType: TensionProcessModal_tension$ref;
export type TensionProcessModal_tension = {|
  +organization: {|
    +viewer: {|
      +$fragmentRefs: TensionGuide_viewer$ref
    |}
  |},
  +$fragmentRefs: TensionGuide_tension$ref & TensionInfo_tension$ref,
  +$refType: TensionProcessModal_tension$ref,
|};
export type TensionProcessModal_tension$data = TensionProcessModal_tension;
export type TensionProcessModal_tension$key = {
  +$data?: TensionProcessModal_tension$data,
  +$fragmentRefs: TensionProcessModal_tension$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TensionProcessModal_tension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TensionGuide_viewer"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TensionGuide_tension"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TensionInfo_tension"
    }
  ],
  "type": "Tension",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '1d447baa76c02eab9ab617659fb9a7e6';

module.exports = node;
